var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSelectStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 22"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 14",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 5"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 10",
    d: "M373.046 2.591h13.218a.971.971 0 1 0 0-1.942h-13.218a.971.971 0 1 0 0 1.942",
    transform: "translate(-368.655 -.131)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 11",
    d: "m385.528 15.419-1.649-4.529a.979.979 0 0 0-.919-.645h-15.696a.979.979 0 0 0-.919.645l-1.645 4.529a.971.971 0 0 0-.059.336 3.361 3.361 0 0 0 1.991 3.066v7.465a1.2 1.2 0 0 0 1.2 1.2h9.637a.979.979 0 0 0 .978-.98v-7.53a3.354 3.354 0 0 0 1.422-.849 3.345 3.345 0 0 0 1.779.933v7.389a.979.979 0 1 0 1.957 0v-7.628a3.362 3.362 0 0 0 1.991-3.066.981.981 0 0 0-.059-.336m-9.046 10.1h-7.9v-6.462a3.345 3.345 0 0 0 1.779-.933 3.344 3.344 0 0 0 4.749 0 3.356 3.356 0 0 0 1.37.835zm7.115-9.492a1.394 1.394 0 0 1-1.362 1.121 1.38 1.38 0 0 1-.6-.138 1.4 1.4 0 0 1-.8-1.26.979.979 0 0 0-1.957 0 1.4 1.4 0 1 1-2.792 0 .979.979 0 0 0-1.957 0 1.4 1.4 0 1 1-2.792 0 .979.979 0 0 0-1.957 0 1.4 1.4 0 0 1-.8 1.26 1.374 1.374 0 0 1-.595.138 1.394 1.394 0 0 1-1.362-1.121c-.009-.042-.021-.083-.026-.126l.026-.07 1.05-2.883.272-.746h14.326l.272.746 1.05 2.883.025.07c0 .043-.017.084-.025.126",
    transform: "translate(-364.112 -6)",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSelectStore);
export default __webpack_public_path__ + "static/media/ic-select-store.34295467dbd3e22030a46a729cfa5597.svg";
export { ForwardRef as ReactComponent };